const receiptRewardsTemplate = require('../../views/receipt-rewards.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('receipt-rewards', {
            url: '/receipt-rewards',
            views: {
                '@': {
                    template: receiptRewardsTemplate
                },
                'receipt-rewards-content@receipt-rewards': {
                    template: '<receipt-rewards></receipt-rewards>'
                }
            },
            data: {
                analytics: 'bws:web:receipt-rewards',
                pageMetadata: {
                    title: 'Receipt Rewards - BWS Online',
                    metaDescription: 'Receipt Rewards - BWS Online'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/receiptRewards.js
 **/